//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useRouter, computed } from '@nuxtjs/composition-api';
import { SfButton, SfImage, SfHeading } from '@storefront-ui/vue';
import { addBasePath } from '@vue-storefront/core';

export default {
  name: 'ErrorLayout',
  props: ['error'],
  components: { SfButton, SfImage, SfHeading },
  layout({ app }) {
    if (app.$storeConfig?.error === 'no_shop_find') {
      return 'blank';
    } else {
      return app?.$storeConfig?.mall_home_type || 'default';
    }
  },
  setup(props) {
    const router = useRouter();
    const title = computed(() => {
      if (props?.error?.title) {
        return props.error.title;
      } else if (props?.error?.statusCode === 404) {
        return 'Page_not_found';
      } else {
        return props?.error?.message || 'An_error_occured';
      }
    });
    const description = computed(() => {
      if (props?.error?.description) {
        return props?.error?.description;
      } else if (props?.error.statusCode === 404) {
        return props?.error?.message || 'Page_not_found';
      } else {
        return props?.error?.message || 'An_error_occured';
      }
    });
    return {
      title,
      description,
      router,
      addBasePath
    };
  }
};
